/** Appended to `desired_start_date` when the screener should also ask about best start timing. */
export const ASK_START_TIMING_PHRASE =
  "Also ask when is the best timing for the candidate to start.";

export const DEFAULT_DESIRED_START_DATE_BASE = "Immediately";

export const desiredStartDateAsksBestTiming = (
  desiredStartDate: string | null | undefined,
): boolean => {
  return (desiredStartDate ?? "").includes(ASK_START_TIMING_PHRASE);
};

export const parseDesiredStartDateBase = (
  raw: string | null | undefined,
): string => {
  const stored = (raw ?? "").trim();
  if (!stored) return DEFAULT_DESIRED_START_DATE_BASE;
  if (!desiredStartDateAsksBestTiming(stored)) return stored;
  const base = stored.replace(ASK_START_TIMING_PHRASE, "").trim();
  return base || DEFAULT_DESIRED_START_DATE_BASE;
};

export const buildDesiredStartDateStored = (
  base: string,
  askTiming: boolean,
): string => {
  const normalizedBase = (base ?? "").trim() || DEFAULT_DESIRED_START_DATE_BASE;
  if (!askTiming) return normalizedBase;
  return normalizedBase
    ? `${normalizedBase}\n${ASK_START_TIMING_PHRASE}`
    : ASK_START_TIMING_PHRASE;
};
